import {
  VStack,
  Heading,
  Text,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import Card from 'components/card/Card';

interface SuccessStateProps {
  title: string;
  description: string;
}

const SuccessState = ({ title, description }: SuccessStateProps) => {
  const bgColor = useColorModeValue('white', 'gray.800');

  return (
    <Card bg={bgColor} p={8} borderWidth="2px" borderColor="green.500">
      <VStack spacing={4}>
        <Icon as={CheckCircleIcon} boxSize={16} color="green.500" />
        <Heading size="md" color="secondaryGray.900">
          {title}
        </Heading>
        <Text textAlign="center" color="gray.600" fontSize="md">
          {description}
        </Text>
      </VStack>
    </Card>
  );
};

export default SuccessState;
